import React, {  useState } from 'react';
import { Button, Card, Spinner } from 'react-bootstrap';
import {   FaCheck, 
    FaBan, 
    FaBagShopping, 
    FaDollarSign,
    FaClock,
    FaReceipt,
    FaComment
} from 'react-icons/fa6';
import { markPedidoAsReadyById,
     markPedidoAsDeliveredById, } from '../../../../../../../../crud/pedidos_api/pedidos';
import {startCookingOrder,
    rejectOrder, 
    OrderReady
} from '../../../../../../../../crud/pedidos_api/delivery_apps';
import { toast } from 'react-toastify';
import { Pedido, Selection } from '../../../../../types';
import CobrarPedido from './components/CobrarPedido/CobrarPedido';
import CancelPedido from './components/CancelPedido/CancelPedido';
import PedidoDetail from './components/PedidoDetail/PedidoDetail';
import './PedidoCard.scss';

interface PedidosCardProps {
    pedido: Pedido;
    pedidos: Pedido[];
    setPedidos: any;
    index: number;
}

const MAX_VISIBLE_ITEMS = 3;

const PedidoCard: React.FC<PedidosCardProps> = ({
     pedidos, 
     setPedidos,
    pedido,
    index }) => {
    const [showCobrarPedido, setShowCobrarPedido] = useState(false);
    const [showMostrarDetalle, setShowMostrarDetalle] = useState(false);
    const [showCancel, setShowCancel] = useState(false);
    const [showAllItems, setShowAllItems] = useState(false);
    const [loading, setLoading] = useState(false);
    const [acceptLoading, setAcceptLoading] = useState(false);
    const [rejectLoading, setRejectLoading] = useState(false);


    function formatHoraEntrega(hora_entrega: string) {
        // fix this function so it returns null when hora_entrega is null
        if (!hora_entrega) {
            return null;
        }
        const date = new Date(hora_entrega);
        return date.toLocaleTimeString('es-ES', { hour: 'numeric', minute: 'numeric' });
    }


    const getSelectionLine = (selection: Selection) => {
        return (
            <div className="cart-item-details">
              {selection.item_name}
                {selection.comment && (
                    <div className="cart-item-comment">
                        <strong>Comentario:</strong> {selection.comment}
                    </div>
                )}
                <div className="cart-item-section">
                    {selection.selection_groups.length !== 0 && (
                        <>
                            <strong>Agregados:</strong>
                            {selection.selection_groups.map(sg => (
                                <div key={sg.selection_group_id} className="selection-group">
                                    <ul className="selection-items">
                                        {sg.selected_items.map(sgi => (
                                            <li key={sgi.item_id}>
                                                {sgi.quantity} x {sgi.item_name || 'Unknown'}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </>
                    )}
                </div>
                <div className="cart-item-section">
                    {selection.modifiers.length > 0 && (
                        <>
                            <strong>Elecciones:</strong>
                            {selection.modifiers.map(mod => (
                                <div key={mod.modifier_id} className="modifier">
                                    {mod.option_name}
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </div>
        );
    };

    const handleMarkAsReady = async (pedido_id: number) => {
        try {
            setLoading(true);
            if (pedido.isManual) {
            const response = await markPedidoAsReadyById(pedido_id);
            const updatedPedidos = pedidos.map(p =>
                p.pedido_id === pedido_id ? { ...p, isReady: true } : p
            );
            setPedidos(updatedPedidos)
            toast.success('Pedido marcado como cocinado');
            } else {
            const response = await OrderReady(
                pedido.third_party_provider_code,
                pedido_id,
                pedido.third_party_provider_id || 0,
                Number(pedido.local_id || 0)
            );
            const updatedPedidos = pedidos.map(p =>
                p.pedido_id === pedido_id ? { ...p, isReady: true } : p
            );
            setPedidos(updatedPedidos);
            toast.success('Pedido marcado como cocinado');
            }
        } catch (error) {
            console.error('Error marking pedido as ready: ', error);
            toast.error('Error marcando pedido como cocinado');
        } finally {
            setLoading(false);
        }
        };

    const handleMarkAsDelivered = async (pedido_id: number) => {
        try {
            setLoading(true);
            const response = await markPedidoAsDeliveredById(pedido_id);
            const updatedPedidos = pedidos.filter(p => p.pedido_id !== pedido_id);
            setPedidos(updatedPedidos);
            toast.success('Pedido marcado como entregado');
        } catch (error) {
            console.error('Error marking pedido as delivered: ', error);
            toast.error('Error marcando pedido como entregado');
        } finally {
            setLoading(false);
        }
        };

    const handleStartCookingOrder = async () => {
        try {
            setAcceptLoading(true);
            const response = await startCookingOrder(
            pedido.third_party_provider_code,
            pedido.pedido_id,
            null,
            pedido.third_party_provider_id || 0,
            Number(pedido.local_id || 0)
            );
            const updatedPedidos = pedidos.map(p =>
            p.pedido_id === pedido.pedido_id ? { ...p, isStarted: true } : p
            );
            setPedidos(updatedPedidos);
            toast.success('Pedido marcado como cocinado');
        } catch (error) {
            console.error('Error marking pedido as ready: ', error);
            toast.error('Error marcando pedido como cocinado');
        } finally {
            setAcceptLoading(false);
        }
        };

    const handleRejectOrder = async () => {
        try {
            setRejectLoading(true);
            const response = await rejectOrder(
                pedido.third_party_provider_code,
                pedido.pedido_id,
                null,
                pedido.third_party_provider_id || 0
            );
            const updatedPedidos = pedidos.filter(p => p.pedido_id !== pedido.pedido_id);
            setPedidos(updatedPedidos);
            toast.success('Pedido rechazado');
        } catch (error) {
            console.error('Error rejecting order: ', error);
            toast.error('Error rechazando pedido');
        } finally {
            setRejectLoading(false);
        }
        };

    const renderProviderLogo = (id: number ) => {
        const providerFiLenameMap: Record<number, string> = {
                    1:'uber-eats.png',
                    2:'rappi.png',
                    3:'pedidos-ya.png',
                    4:'JUSTO.png',
                    7:'didi-food.jpg',
        }
        const filename = providerFiLenameMap[id as number] || 'logo.png'
        return(
          <div className="delivery-provider-logo">
            <img 
              alt="logo"
              className="logo-img"
              src={`${process.env.PUBLIC_URL}/icons/providers/${filename}`} 
            />
        </div>
        )
      }

    const renderFooter = () => {
        return (
            <React.Fragment>
                  <Card.Footer className="delivery-pedido-card-footer">

                {(pedido.isStarted || pedido.isManual) && (
                    <>
                        {/* Botón Anular siempre visible */}
                        <Button
                            className='mp-button'
                            variant="none"
                            onClick={() => {
                                setShowCancel(true);
                            }}
                        >
                            <span>   Anular </span><FaBan />
                        </Button>

                        {/* Botón Cocinado */}
                        {!pedido.isReady && 
                            <Button
                                className='mp-button'
                                variant="none"
                                disabled={loading}
                                onClick={() => handleMarkAsReady(pedido.pedido_id)}
                            >
                                {loading
                                    ? <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : <>
                                        <span> Cocinado </span>
                                        <FaCheck />
                                    </>
                                }
                            </Button>
                        }

                        {/* Botón Entregado */}
                        {(!pedido.isDelivered && pedido.payed) && (
                            <Button
                                className='mp-button'
                                variant="none"
                                disabled={loading}
                                onClick={() => handleMarkAsDelivered(pedido.pedido_id)}
                            >
                                {loading
                                    ? <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    : <>
                                        <span> Entregado </span>
                                        <FaBagShopping />
                                    </>
                                }
                            </Button>
                        )}

                        {/* Botón Cobrar/Ver recibo */}
                        {!pedido.payed && 
                            <Button
                                className='mp-button'
                                variant="none"
                                onClick={() => setShowCobrarPedido(true)}
                            >
                                {!pedido.receipt_id && <>  <span>Cobrar </span> <FaDollarSign /> </>} 
                                {pedido.receipt_id && <> <span>Ver recibo </span> <FaReceipt /> </>}
                            </Button>
                        }
                    </>
                )}
                {!pedido.isStarted && pedido.third_party_provider_id !== null && !pedido.isManual && (
                    <Button
                        className='mp-button'
                        variant="none"
                        disabled={rejectLoading}
                        onClick={handleRejectOrder}
                    >
                        {rejectLoading
                            ? <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            : 'Rechazar'
                        }
                    </Button>
                    )}
                    {!pedido.isStarted && pedido.third_party_provider_id !== null && !pedido.isManual && (
                        <Button
                            className='mp-button'
                            variant="none"
                            disabled={acceptLoading}
                            onClick={handleStartCookingOrder}
                        >
                            {acceptLoading
                                ? <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                : <>
                                    <span> Aceptar </span>
                                    <FaCheck />
                                </>
                            }
                        </Button>
                        )}
            </Card.Footer>
            </React.Fragment>
        )}

    const visibleSelections = showAllItems
    ? pedido.selections
    : pedido.selections.slice(0, MAX_VISIBLE_ITEMS);

    return (
        <>
        <Card className="delivery-pedido-card">
                        <Card.Header className="delivery-pedido-card-header">
                            <div>
                                <Card.Title className='id-pedido-pedido-delibery'>
                                        <span>
                                        #{pedido.pedido_id.toString().slice(-4)}
                                        </span>
                                        <span>
                                        {pedido.client_name}
                                        </span>
                                </Card.Title>
                                {pedido.comment && (
                                    <div className="pedido-comment">
                                        <span className="comment-icon"> <FaComment/></span>
                                        <span className="comment-text">{pedido.comment}</span>
                                    </div>
                                )}
                            </div>

                            {pedido.third_party_provider_id && renderProviderLogo(pedido.third_party_provider_id)}

                            <div className="pedidos-displayer-timer">
                               {(pedido.hora_entrega !== "None") && <>
                               <FaClock/> Entrega {formatHoraEntrega(pedido.hora_entrega)}
                               </>}
                            </div>

                        </Card.Header>
                        <Card.Body className='delivery-pedido-card-body'>
                
                        <div className="delivery-pedido-items">
                            {visibleSelections.map((selection, itemIndex) => (
                            <div key={itemIndex} className="delivery-pedido-item-row">
                                <div className="delivery-item-text">
                                <span className="selection-item-quantity">
                                    {selection.quantity} x{' '}
                                </span>
                                {getSelectionLine(selection)}
                                </div>

                            </div>
                            ))}
                            {pedido.selections.length > MAX_VISIBLE_ITEMS && (
                            <Button
                                variant="none"
                                className="ver-mas-btn"
                                onClick={() => setShowAllItems(!showAllItems)}
                            >
                                {showAllItems ? 'Ver menos' : 'Ver más'}
                            </Button>
                            )}
                        </div>
                  

                           
                        </Card.Body>
                        {renderFooter()}
                    </Card>

            <CobrarPedido
                pedido={pedido}
                setPedidos={setPedidos}
                show={showCobrarPedido}
                setShow={setShowCobrarPedido}
            />
            <PedidoDetail
                pedido={pedido}
                show={showMostrarDetalle}
                setShow={setShowMostrarDetalle}
                setPedidos={setPedidos}
                pedidos={pedidos}
            />
            <CancelPedido
                pedido={pedido}
                setPedidos={setPedidos}
                show={showCancel}
                setShow={setShowCancel}
            />

        </>
    );
};

export default PedidoCard;
